import React, { useContext, useEffect, useRef, useState } from 'react';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';
import { toast } from 'react-toastify';
import useWorkerService from '../../app/services/hooks/useWorkerService';
import { getDefaultMonthDateRange } from '../../helpers';
import ButtonSearchFilter from '../../components/buttons/ButtonSearchFilter';
import CommissionsContainer from './components/CommissionsContainer';
import CheckingAccountContainer from './components/CheckingAccountContainer';
import TravelExpensesCheckingAccountContainer from './components/TravelExpensesCheckingAccountContainer';
import TravelExpensesContainer from './components/TravelExpensesContainer';
import { formatMoney } from '../../utils/utils';
import { TransportOrderFilters } from '../../app/models/TransportOrder';
import { ExpenseFilters } from '../../app/models/Expense';
import { TollExpenseFilters } from '../../app/models/TollExpense';
import { CheckingAccountFilters } from '../../app/models/CheckingAccount';
import { InternalSettlementFilters } from '../../app/models/InternalSettlement';
import InternalSettlementsFilter from './components/tables/InternalSettlementsFilter';
import { AuthContext } from '../../contexts/AuthContext';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Liquidación interna',
        url: '/internal-settlements',
        isActive: true
    }
];

const InternalSettlements = () => {

    const { auth } = useContext(AuthContext);
    const [hasPermissions, setHasPermissions] = useState(false);


    const { hasFinancialSummaryPermission, 
        fetchingFinancialSummaryPermission } = useWorkerService();

    useEffect(() => {
         hasFinancialSummaryPermission({
            onSuccess: (response: ServiceResponse) => {
                setHasPermissions(response.data.has_permission)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        })
    },[])

    const [travelExpenseCheckingAccountTotal, setTravelExpenseCheckingAccountTotal] = useState(0);
    const [checkingAccountTotal, setCheckingAccountTotal] = useState(0);
    const [commissionTotal, setCommissionTotal] = useState(0); 
    const [tollExpensesTotalAmount, setTollExpensesTotalAmount] = useState(0);
    const [expensesTotalAmount, setExpensesTotalAmount] = useState(0);

    const [readyFlags, setReadyFlags] = useState({
        travelExpenses: false,
        checking: false,
        commission: false,
        toll: false,
        expenses: false,
        });

    const handleCommissionTotal = (value: number) => {
        setCommissionTotal(value);
        setReadyFlags(prev => ({ ...prev, commission: true }));
    };

    const handleCheckingTotal = (value: number) => {
        setCheckingAccountTotal(value);
        setReadyFlags(prev => ({ ...prev, checking: true }));
    };

    const handleTravelExpensesTotal = (value: number) => {
        setTravelExpenseCheckingAccountTotal(value);
        setReadyFlags(prev => ({ ...prev, travelExpenses: true }));
    };

    const handleTollTotal = (value: number) => {
        setTollExpensesTotalAmount(value);
        setReadyFlags(prev => ({ ...prev, toll: true }));
    };

    const handleExpensesTotal = (value: number) => {
        setExpensesTotalAmount(value);
        setReadyFlags(prev => ({ ...prev, expenses: true }));
    };

    const [total, setTotal] = useState(0);

    useEffect(() => {

        const allReady = Object.values(readyFlags).every(flag => flag);

        if (allReady) {
            const sum =
            travelExpenseCheckingAccountTotal +
            checkingAccountTotal +
            commissionTotal +
            tollExpensesTotalAmount +
            expensesTotalAmount;

            setTotal(sum);
        }
    },[
        readyFlags,
        travelExpenseCheckingAccountTotal,
        checkingAccountTotal,
        commissionTotal,
        tollExpensesTotalAmount,
        expensesTotalAmount
    ])
    

    // // EStados filtros

    const [dateRange, setDateRange] = useState(() => getDefaultMonthDateRange());

    const [internalSettlementFilter, setInternalSettlementFilters] = useState<InternalSettlementFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            issue_date_from: dateRange.startDate,
            issue_date_until: dateRange.endDate,
        });

    const [transportOrderFilter, setTransportOrderFilter] = useState<TransportOrderFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            program_date_from: dateRange.startDate,
            program_date_until: dateRange.endDate,
        });

    const [expensesFilter, setExpensesFilter] = useState<ExpenseFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            issue_date_first: dateRange.startDate,
            issue_date_last: dateRange.endDate
        });

    const [tollExpensesFilter, setTollExpensesFilter] = useState<TollExpenseFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            issue_date_first: dateRange.startDate,
            issue_date_last: dateRange.endDate
        });

    const [checkingAccountsFilter, setCheckingAccountsFilter] = useState<CheckingAccountFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            issue_date_first: dateRange.startDate,
            issue_date_last: dateRange.endDate,
            transfer_reason: 'non_travel_expenses'
        });
    
    const [travelExpensesCheckingAccountsFilter, setTravelExpensesCheckingAccountsFilter] = useState<CheckingAccountFilters>({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            issue_date_first: dateRange.startDate,
            issue_date_last: dateRange.endDate,
            transfer_reason: 'Viaticos'
        });

    const [travelEspensesFilter, setTravelEspensesFilter] = useState<any>({
            first_day: dateRange.startDate,
            last_day: dateRange.endDate,
            carrier: ''
        });


        // FILTRO
    const onSearch = () => {

        setTotal(0)

          setReadyFlags({
            travelExpenses: false,
            checking: false,
            commission: false,
            toll: false,
            expenses: false,
        });

        setCheckingAccountsFilter({
            ...checkingAccountsFilter,
            issue_date_first: internalSettlementFilter.issue_date_from,
            issue_date_last: internalSettlementFilter.issue_date_until,
            carrier: internalSettlementFilter.carrier
        });
        setTravelExpensesCheckingAccountsFilter({
            ...travelExpensesCheckingAccountsFilter,
            issue_date_first: internalSettlementFilter.issue_date_from,
            issue_date_last: internalSettlementFilter.issue_date_until,
            carrier: internalSettlementFilter.carrier
        });
        setTransportOrderFilter({
            ...transportOrderFilter,
            program_date_from: internalSettlementFilter.issue_date_from,
            program_date_until: internalSettlementFilter.issue_date_until,
            carrier: internalSettlementFilter.carrier
        });
        setTravelEspensesFilter({
            ...travelEspensesFilter,
            first_day: internalSettlementFilter.issue_date_from,
            last_day: internalSettlementFilter.issue_date_until,
            carrier: internalSettlementFilter.carrier
        });
        setExpensesFilter({
            ...expensesFilter,
            issue_date_first: internalSettlementFilter.issue_date_from,
            issue_date_last: internalSettlementFilter.issue_date_until,
            carrier: internalSettlementFilter.carrier
        });
        setTollExpensesFilter({
            ...tollExpensesFilter,
            issue_date_first: internalSettlementFilter.issue_date_from,
            issue_date_last: internalSettlementFilter.issue_date_until,
            carrier: internalSettlementFilter.carrier
        })
    }




    return (
        <>
            <DefaultCard>
                { hasPermissions ? (
                    <div>
                        <div className="h3 mt-0 mb-4 card-title">Resumen Financiero</div>

                        {/* FILTROS FECHA Y CONDUCTOR */}

                        <div className="row justify-content-start mb-4">

                            <InternalSettlementsFilter 
                                filter={internalSettlementFilter} 
                                setFilter={setInternalSettlementFilters} 
                                onSearch={onSearch}                            
                            />
                            
                        </div>

                        <CommissionsContainer
                            transportOrderFilter={transportOrderFilter}
                            setTransportOrderFilter={setTransportOrderFilter}
                            expensesFilter={expensesFilter}
                            setExpensesFilter={setExpensesFilter}
                            tollExpensesFilter={tollExpensesFilter}
                            setTollExpensesFilter={setTollExpensesFilter}
                            setCommissionTotal={handleCommissionTotal}
                            commissionTotal={commissionTotal}
                            setTollExpensesTotalAmount={handleTollTotal}
                            tollExpensesTotalAmount={tollExpensesTotalAmount}
                            setExpensesTotalAmount={handleExpensesTotal}
                            expensesTotalAmount={expensesTotalAmount}
                        />

                        <div className="row justify-content-start">
                            <CheckingAccountContainer 
                                checkingAccountsFilter={checkingAccountsFilter} 
                                setCheckingAccountsFilter={setCheckingAccountsFilter}         
                                setCheckingAccountTotal={handleCheckingTotal}
                                checkingAccountTotal={checkingAccountTotal}             
                            />

                            <TravelExpensesCheckingAccountContainer 
                                checkingAccountsFilter={travelExpensesCheckingAccountsFilter} 
                                setCheckingAccountsFilter={setTravelExpensesCheckingAccountsFilter}       
                                setTravelExpenseCheckingAccountTotal={handleTravelExpensesTotal}
                                travelExpenseCheckingAccountTotal={travelExpenseCheckingAccountTotal}             
                            />

                        </div>


                        {/* Acá habría que desarrollar buscar fechas sin worker id */}


                        {/* {(auth?.roles?.includes('Conductor')) && (

                            <div className="row justify-content-start">
                                <TravelExpensesContainer 
                                    travelEspensesFilter={travelEspensesFilter} 
                                    setTravelEspensesFilter={setTravelEspensesFilter} 
                                    setTravelExpensesTotal={setTravelExpensesTotal}
                                    travelExpensesTotal={travelExpensesTotal}    
                                />
                            </div>

                        )} */}

                        <div className="row justify-content-start">
                            <div className="col-lg-3">
                                <div
                                    className="mini-stats-wid card p-2"
                                    style={{
                                        backgroundColor: '#D1C7A3',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                    }}
                                >
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <p className="fw-medium " style={{ userSelect: 'none' }}>Total</p>
                                            <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(total)}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                    ) : <div> No tiene los permisos necesarios</div>
                }
                
            </DefaultCard>
        </>
    );


};

export default InternalSettlements;
